import { useQuery, useMutation } from "@tanstack/react-query";
import { Api_EndPoints } from "../utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";

const getAllLeaves = async ({ companyCode,isTrue=true }) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetLeaveTypes}?companyCode=${companyCode}&isTrue=${isTrue}`
  );
  return data;
};

export const useGetAllLeaveTypesQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetLeaveTypes],
    queryFn: () => getAllLeaves(companyCode),
    refetchOnWindowFocus: false,
  });
};

const addLeave = async (input) => {
  const data = await http_payroll.post(Api_EndPoints.InsertLeaveMaster, input);
  return data;
};

export const useAddLeaveMutation = () => {
  return useMutation({
    mutationFn: addLeave,
  });
};

const updateLeave = async (input) => {
  const data = await http_payroll.put(Api_EndPoints.UpdateLeaveMaster, input);
  return data;
};

export const useUpdateLeaveMutation = () => {
  return useMutation({
    mutationFn: updateLeave,
  });
};
